import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Workspace Redux State
 *
 * Minimal state management for workspace context.
 * Only stores the active workspace ID - all workspace data is managed by TanStack Query.
 */
interface WorkspaceState {
  activeWorkspaceId: string | null;
  lastAccessedWorkspaceId: string | null;
}

const initialState: WorkspaceState = {
  activeWorkspaceId: null,
  lastAccessedWorkspaceId: null,
};

const workspaceSlice = createSlice({
  name: "workspace",
  initialState,
  reducers: {
    setActiveWorkspace: (state, action: PayloadAction<string>) => {
      state.activeWorkspaceId = action.payload;
      state.lastAccessedWorkspaceId = action.payload;
    },
    clearActiveWorkspace: (state) => {
      state.activeWorkspaceId = null;
    },
    setLastAccessedWorkspace: (state, action: PayloadAction<string>) => {
      state.lastAccessedWorkspaceId = action.payload;
    },
  },
});

export const { setActiveWorkspace, clearActiveWorkspace, setLastAccessedWorkspace } =
  workspaceSlice.actions;
export default workspaceSlice.reducer;
